import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { toast } from 'react-toastify';
import { get_user_info } from '../../../helpers/api';
import { generatePath, useHistory } from 'react-router-dom';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import { useDispatch } from 'react-redux';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import { Coin } from '../../../assets/icons/iconComponents2';
import Avatar from '@material-ui/core/Avatar';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import { routes } from '../../../assets/routes';
import Like from '../../common/Like';
import Loader from '../../common/Loader';
import { Edit } from '../../../assets/icons/iconComponents';
import Button from '@mui/material/Button';
import { modules } from '../../../helpers/modules';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  editKudosRequest,
  getKudosRequest,
  getKudosCommentListRequest,
  getKudosLikeListRequest,
  sendCommentRequest,
  deleteCommentRequest,
  editCommentRequest
} from './api';
import { TextField } from '@mui/material';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import StyledTab from '../../common/tabs/SimpleTab';
import { a11yProps } from '../../../helpers/utils';
import classNames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import { IconButton } from '@material-ui/core';
import IosShareIcon from '@mui/icons-material/IosShare';
import Comment from '../../common/comments';
import LikeInfoCard from './LikeInfoCard';
import { useTranslation } from '../../../i18n/LanguageProvider';

const KudosDetail = () => {
  const { t, isRtl } = useTranslation();
  const queryClient = useQueryClient();
  const history = useHistory();
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [note, setNote] = useState('');
  const id = history.location.pathname.split('/')[2];
  const [tabIndex, setTabIndex] = useState(0);
  const [comment, setComment] = useState(null);
  const myId = get_user_info()?.id;

  const openProfile = (id) => () => {
    history.push(generatePath(routes.PROFILE, { id }));
  };

  const { isLoading, data, isFetching, refetch } = useQuery(
    ['kudos', id],
    () => getKudosRequest(id),
    {
      onSuccess(response) {
        setNote(response.data.note);
      },
      onError(error) {
        toast.error(error.response?.data?.detail);
      }
    }
  );

  const {
    data: commentListData,
    isLoading: commentListIsLoading,
    refetch: commentListRefetch
  } = useQuery(['commentList', id], () => getKudosCommentListRequest(id), {
    onError(error) {
      toast.error(error.response?.data?.detail);
    }
  });

  const { data: likeListData, isLoading: likeListIsLoading } = useQuery(
    ['likeList', id],
    () => getKudosLikeListRequest(id),
    {
      onError(error) {
        toast.error(error.response?.data?.detail);
      }
    }
  );

  const editKudosMutation = useMutation(editKudosRequest, {
    onSuccess(data) {
      queryClient.setQueryData(['kudos', id], () => data);
      setNote(data.data.note);
      setEditable(false);
    },
    onError(error) {
      toast.error(error.response?.data?.detail);
    }
  });

  const sendCommentMutation = useMutation(sendCommentRequest, {
    onSuccess() {
      setComment('');
      toast.success(t('comments.sent'));
      commentListRefetch();
      refetch();
    },
    onError(error) {
      toast.error(error.response?.data?.detail);
    }
  });

  const deleteCommentRequestMutation = useMutation(deleteCommentRequest, {
    onSuccess() {
      commentListRefetch();
      toast.success(t('comments.deleted'));
      queryClient.invalidateQueries(['kudos']);
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const editCommentRequestMutation = useMutation(editCommentRequest, {
    onSuccess() {
      commentListRefetch();
      toast.success(t('comments.edited'));
    },
    onError(error) {
      toast.error(error.response?.data?.detail);
    }
  });

  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));
  useEffect(() => {
    setHeader(t('kudos.title'));
    setHeaderConfigs({ credits: false, exit: false, back: true, logo: false });
  }, []);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  return (
    <div className={styles.page}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.wrapper}>
            <div className={styles.kudos}>
              <div className={styles.imgWrapper}>
                <img
                  src={data.data?.card?.photo?.absolute_url || DefaultAvatar}
                  alt="kudos card"
                />
              </div>
              <div className={styles.kudosInfo}>
                <span>{data.data?.card?.title}</span>
                {!!data?.data?.coin && (
                  <div className={styles.coins}>
                    <Coin />
                    <span>{data?.data?.coin}</span>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.top}>
              <div className={styles.info}>
                <div
                  className={styles.person}
                  onClick={openProfile(data.data?.sender?.id)}
                >
                  <Avatar
                    alt={data.data?.sender?.first_name}
                    src={data.data?.sender?.avatar?.thumbnail || DefaultAvatar}
                    className={styles.small}
                  />
                  <span>
                    {data.data?.sender?.first_name}{' '}
                    {data.data?.sender?.last_name}
                  </span>
                </div>
                <ArrowBackIosRoundedIcon className="flip-ltr" />
                <div className={styles.receivers}>
                  {modules.group_reco ? (
                    data.data?.receivers?.map((receiver, index) => (
                      <div
                        key={index}
                        className={styles.person}
                        onClick={openProfile(receiver.id)}
                      >
                        <Avatar
                          alt={receiver.first_name}
                          src={receiver.avatar?.thumbnail || DefaultAvatar}
                          className={styles.small}
                        />
                        <span>
                          {receiver.first_name} {receiver.last_name}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div
                      className={styles.person}
                      onClick={openProfile(data.data?.receiver?.id)}
                    >
                      <Avatar
                        alt={data.data?.receiver?.first_name}
                        src={
                          data.data?.receiver?.avatar?.thumbnail ||
                          DefaultAvatar
                        }
                        className={styles.small}
                      />
                      <span>
                        {data.data?.receiver?.first_name}{' '}
                        {data.data?.receiver?.last_name}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.note}>
              {editable ? (
                <div className={styles.edit}>
                  <TextField
                    id="about"
                    className={styles.input}
                    name="about"
                    type="text"
                    multiline
                    hiddenLabel
                    onChange={(e) => setNote(e.target.value)}
                    value={note}
                  />
                  <Button
                    onClick={() => editKudosMutation.mutate({ note, id })}
                    variant="contained"
                    style={{ marginInlineEnd: '16px' }}
                    disabled={editKudosMutation.isLoading}
                    size="small"
                  >
                    {editKudosMutation.isLoading ? (
                      <Loader size={20} />
                    ) : (
                      t('common.confirm')
                    )}
                  </Button>
                  <Button
                    onClick={() => {
                      setNote(data.data.note);
                      setEditable(false);
                    }}
                    variant="outlined"
                    size="small"
                  >
                    {t('common.cancel')}
                  </Button>
                </div>
              ) : (
                <>
                  <p className={styles.note} dir="auto">
                    {data.data?.note}
                  </p>
                  {data.data?.sender?.id === get_user_info().id && (
                    <Edit
                      onClick={() => {
                        setEditable(true);
                      }}
                    />
                  )}
                </>
              )}
            </div>
            <Like
              isFetching={isFetching}
              likesCount={data.data?.likes_count}
              likedByMe={data.data?.liked_by_me}
              commentsCount={data.data?.comments_count}
              id={id}
            />
          </div>

          <div className={styles.section}>
            <div className={styles.sectionTop}>
              <SimpleTabs value={tabIndex} handleChange={handleChange}>
                <StyledTab label={t('kudos.comments')} {...a11yProps(0)} />
                <StyledTab label={t('kudos.likes')} {...a11yProps(1)} />
              </SimpleTabs>
            </div>
            <SwipeableViews
              axis={isRtl ? 'x-reverse' : 'x'}
              index={tabIndex}
              onChangeIndex={handleChangeIndex}
              className={styles.swipeArea}
            >
              <TabPanel index={0} value={tabIndex}>
                {commentListIsLoading ? (
                  <Loader />
                ) : commentListData?.length ? (
                  <div
                    className={classNames(styles.noMargin, styles.sectionBody)}
                  >
                    {commentListData?.map((comment) => (
                      <Comment
                        key={comment.id}
                        subComments={comment.sub_comments}
                        kudosId={id}
                        commentId={comment.id}
                        comment={comment.comment}
                        createdAt={comment.created_at}
                        editable={myId === comment.sender.id}
                        loading={
                          editCommentRequestMutation.isLoading ||
                          deleteCommentRequestMutation.isLoading
                        }
                        onProfileClick={() =>
                          history.push(
                            generatePath(routes.PROFILE, {
                              id: comment.sender.id
                            })
                          )
                        }
                        senderUser={{
                          first_name: comment.sender.first_name,
                          last_name: comment.sender.last_name,
                          avatar: comment.sender.avatar?.thumbnail
                        }}
                        onDeleteComment={() => {
                          deleteCommentRequestMutation.mutate({
                            id: comment.id
                          });
                        }}
                        onEditComment={(newComment) =>
                          editCommentRequestMutation.mutate({
                            comment: newComment,
                            id: comment.id
                          })
                        }
                        sendCommentMutation={sendCommentMutation}
                      />
                    ))}
                  </div>
                ) : (
                  <div className={styles.empty}>{t('kudos.noComments')}</div>
                )}
              </TabPanel>
              <TabPanel index={1} value={tabIndex}>
                {likeListIsLoading ? (
                  <Loader />
                ) : likeListData?.length ? (
                  <div
                    className={classNames(styles.noMargin, styles.sectionBody)}
                  >
                    {likeListData?.map((like) => (
                      <LikeInfoCard
                        data={like}
                        key={like.id}
                        extraClass={styles.card}
                      />
                    ))}
                  </div>
                ) : (
                  <div className={styles.empty}>{t('kudos.noLikes')}</div>
                )}
              </TabPanel>
            </SwipeableViews>
          </div>
          {tabIndex === 0 && (
            <form
              className={styles.comment}
              onSubmit={(e) => {
                e.preventDefault();
                sendCommentMutation.mutate({ kudos_id: id, comment: comment });
              }}
            >
              <TextField
                onChange={(e) => setComment(e.target.value)}
                name="comment"
                value={comment}
                fullWidth
                label={t('comments.placeholder')}
                defaultValue={comment}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={sendCommentMutation.isLoading}>
                      {!!comment && (
                        <IosShareIcon
                          onClick={() => {
                            sendCommentMutation.mutate({
                              kudos_id: id,
                              comment: comment
                            });
                          }}
                          color="primary"
                        />
                      )}
                    </IconButton>
                  )
                }}
              />
            </form>
          )}
        </>
      )}
    </div>
  );
};

export default KudosDetail;
